import React from 'react';
import { motion } from 'framer-motion';

const GoldBar = ({ delay = 0, size = 'md' }) => {
  const sizes = {
    sm: 'w-6 h-4',
    md: 'w-8 h-5',
    lg: 'w-10 h-6'
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.4, delay, type: "spring", stiffness: 200 }}
      className={`${sizes[size]} relative`}
    >
      {/* 3D Gold Bar */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#F5ECD7] via-[#D4AF37] to-[#B8960C] rounded-sm shadow-lg transform-gpu">
        {/* Shine effect */}
        <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/30 to-transparent opacity-60 rounded-sm" />
        {/* Top face */}
        <div className="absolute -top-1 left-0.5 right-0.5 h-1.5 bg-gradient-to-b from-[#F5ECD7] to-[#D4AF37] rounded-t-sm transform skew-x-12" />
      </div>
    </motion.div>
  );
};

const GoldVisualizer = ({ grams, maxGrams = 1000 }) => {
  // Calculate how many bars to show (max 20 for visual clarity)
  const normalizedGrams = Math.min(grams, maxGrams);
  const barCount = Math.min(Math.max(Math.ceil(normalizedGrams / 50), 1), 20);
  
  // Group bars in rows of 5
  const rows = Math.ceil(barCount / 5);
  
  return (
    <div className="flex flex-col items-center gap-1">
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={rowIndex} className="flex gap-1 justify-center">
          {Array.from({ length: Math.min(5, barCount - rowIndex * 5) }).map((_, barIndex) => (
            <GoldBar 
              key={barIndex} 
              delay={0.1 + (rowIndex * 5 + barIndex) * 0.05}
              size={rows > 2 ? 'sm' : 'md'}
            />
          ))}
        </div>
      ))}
      
      {/* Weight label */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 + barCount * 0.05 }}
        className="mt-2 text-center"
      >
        <span className="text-xs text-gray-500">Visual representation</span>
      </motion.div>
    </div>
  );
};

export default GoldVisualizer;
